import React from 'react'

const Footer = () => (
    <footer className="footer">
      <div className="container">
        <p>© 2020 Castle Rock Data LLC - PhotoBook</p>
      </div>
    </footer>
);

export default Footer
